/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_End_LineInputs */

const en_us2_share_end_line = /** @type {(inputs: Share_End_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence-based training.`)
};

const pt_br2_share_end_line = /** @type {(inputs: Share_End_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino com base em evidência.`)
};

const es_419_share_end_line = /** @type {(inputs: Share_End_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento basado en evidencia.`)
};

const pt_pt2_share_end_line = /** @type {(inputs: Share_End_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino com base em evidência.`)
};

const fr_fr2_share_end_line = /** @type {(inputs: Share_End_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'entraînement fondé sur les preuves.`)
};

const de_de2_share_end_line = /** @type {(inputs: Share_End_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidenzbasiertes Training.`)
};

const it_it2_share_end_line = /** @type {(inputs: Share_End_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento basato sulle evidenze.`)
};

/**
* | output |
* | --- |
* | "Evidence-based training." |
*
* @param {Share_End_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_end_line = /** @type {((inputs?: Share_End_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_End_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_end_line(inputs)
	if (locale === "es-419") return es_419_share_end_line(inputs)
	if (locale === "pt-PT") return pt_pt2_share_end_line(inputs)
	if (locale === "fr-FR") return fr_fr2_share_end_line(inputs)
	if (locale === "de-DE") return de_de2_share_end_line(inputs)
	if (locale === "it-IT") return it_it2_share_end_line(inputs)
	return en_us2_share_end_line(inputs)
});
export { share_end_line as "share.end_line" }